export const QTYPES = {
  AUDIO: "audio",
  AUDIO_FIRST: "audioFirst",
  VIDEO_FIRST: "videoFirst",
  FEEDBACK: "feedback",
  FILLER: "filler",
  FILTRATION: "filtration",
  HYGIENE_CHECK: "hygiene check",
  INFORMATIVE: "informative",
  MCQ: "mcq",
  MCR: "mcr",
  MOBILE_NUMBER: "mobile number",
  NAME: "full name",
  NOT_INTERESTED: "not being interested",
  OTP: "otp",
  PLAYBACK: "Press the play button now",
  RATING: "rating",
  SKILL_BASED: "skillBased",
  STARS: "will you rate me",
  TEXTBOX: "textbox",
  VIDEO: "video",
};
